<div class="sub-chrome-container">
    <div class="title-area">
        <span class="h1-light text-ellipsis">{{name}}</span>
    </div>
    <div class="operation-box">
        <button tam-button tamType="tertiary" tamSize="normal" (click)="onCancel()">Cancel</button>
        <button tam-button tamType="primary" tamSize="normal" (click)="onSave()" [tamLoading]="isProgressing"
            [disabled]="isProgressing">Save</button>
    </div>
</div>